import { Component, OnInit } from '@angular/core';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { environment } from 'src/environments/environment.dev';

declare var Examedi: any;

@Component({
  selector: 'app-otros-beneficios',
  templateUrl: './otros-beneficios.component.html',
  styleUrls: ['./otros-beneficios.component.css']
})
export class OtrosBeneficiosComponent implements OnInit {
  isModalOpen = false;
  pageInfo: any = {};
  beneficios: any[] = [];
  private examediApp: any = null;

  private examediClientId = environment.examediClientId;

  constructor(
    private encriptacionService: EncriptacionService
  ) { }

  ngOnInit(): void {
  this.pageInfo = this.encriptacionService.getPageInfo();
  console.log(this.pageInfo);

  this.cargarBeneficios();

  if (this.pageInfo?.cus_can_examedi) {
    this.initExamedi();
  }
}

  cargarBeneficios(): void {
    this.beneficios = [];

    if (this.pageInfo?.cus_can_examedi) {
      this.beneficios.push({
        nombre: 'Examedi',
        logo: 'assets/images/examedi-logo2.png',
        titulo: 'Agenda y cotiza tus exámenes en línea',
        descripcion: 'Con Examedi puedes cotizar las órdenes de exámenes generadas en tu consulta y agendar tus exámenes médicos a domicilio.',
        tipo: 'examedi'
      });
    }
  }

  initExamedi(): void {
  try {
    if (!this.examediClientId) {
      console.error('No existe examediClientId en environment');
      return;
    }

    if (typeof Examedi !== 'undefined') {
      this.examediApp = new Examedi();
      this.examediApp.init({
        clientId: this.examediClientId
      });
    } else {
      console.error('Examedi SDK no está disponible');
    }
  } catch (error) {
    console.error('Error inicializando Examedi:', error);
  }
}

  openExamedi(): void {
    try {
      if (this.examediApp) {
        this.examediApp.open();
      } else {
        console.error('Examedi no fue inicializado');
      }
    } catch (error) {
      console.error('Error abriendo Examedi:', error);
    }
  }

  openModal(): void {
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }
}